import React from "react";


export default function LoadingAnimation(props) {

    function createWrapper(children){
        if(!props.mask) return children
        return <div className={"loading-container"}>
            <div className={"loading-screen"}>
                {children}
            </div>
            <div className="loading-overlay"/>
        </div>
    }

    const renderSVG =()=> {
        const svgs = {
            arrows: (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 256 256"><path className="arrow_1" fill="#000000" d="M153.047,224.742l102.953,0l-0,-191.963l-80.122,0l15.102,-15.101l-17.678,-17.678l-45.255,45.255l0.025,0.024l-0.025,0.025l45.255,45.254l17.678,-17.677l-15.102,-15.102l55.122,0l0,141.963l-48.36,0l-29.593,25Z"/><path className="arrow_2" fill="#666666" d="M102.953,31.258l-102.953,-0l0,191.963l80.122,-0l-15.102,15.101l17.678,17.678l45.255,-45.255l-0.025,-0.024l0.025,-0.025l-45.255,-45.254l-17.678,17.677l15.102,15.102l-55.122,-0l-0,-141.963l48.683,-0l29.27,-25Z"/></svg>),
            arrows_mask: (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 256 256" clipRule="evenodd" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" className="arrows_mask"><path fill={(props.bg || "var(--color-bg-content)")} d="m0 223.22v32.779h82.698l-17.678-17.678 15.102-15.101h-80.122zm-0-223.22v31.258h102.95l-29.27 25h-48.683v141.96h55.122l-15.102-15.102 17.678-17.677 45.255 45.254-.025.025.025.024-45.255 45.255h173.3v-256h-256zm153.05 224.74h102.95v-191.96h-80.122l15.102-15.101-17.678-17.678-45.255 45.255.025.024-.025.025 45.255 45.254 17.678-17.677-15.102-15.102h55.122v141.96h-48.36l-29.593 25z"/></svg>)
        }
        if(!svgs[props.type]) return
        return svgs[props.type]
    }

    const txtArr = ['p','r','o','d','e']//,'c','t']
    const bars = txtArr.map((it, i)=> {
        return <div key={"bar-" + i} className={"bar-" + (i + 1)} style={{backgroundColor: props.color}}>{(props.showtext ? it : '')}</div>
    })

    return createWrapper(
        <div className={"loading-animation" + (props.size ? "-" + props.size : "") + (props.cssClasses ? " " + props.cssClasses : "")} style={{color: props.color}}>
            <div>{(props.type ? renderSVG() : bars)}</div>
            {(props.text ? <span>{props.text}</span> : '')}
        </div>
    )
}